import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4" data-id="element-54">
        <p className="font-bold text-white text-xl mb-4" data-id="element-55">
          Barre: La evolución de tu estudio
        </p>
        <p className="mb-6 text-sm" data-id="element-56">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <div className="flex justify-center gap-6 text-sm mb-6" data-id="element-57">
          <a href="#" className="hover:text-white transition-colors" data-id="element-58">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Políticas de Privacidad
          </a>
        </div>
        <p className="text-xs" data-id="element-60">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
};